import { useLanguage } from "@/i18n";

export const Marquee = ({ settings }) => {
  const { pick } = useLanguage();
  const text = pick(settings.marquee) || "TATTOO STUDIO";
  const row = Array.from({ length: 6 }, () => text);
  return (
    <div className="border-y border-white/10 py-6 overflow-hidden" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((txt, i) => (
              <span key={i} className={`font-display uppercase text-5xl sm:text-7xl tracking-wider px-8 flex items-center gap-8 ${i % 2 ? "text-outline" : ""}`}>
                {txt}
                <span className="text-[#E63946] text-2xl">◆</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
